var map = {
	"./about_mission_vision.jpg": 62894,
	"./astrorei-cta.jpg": 92283,
	"./astrorei-team-sviluppatori-software.jpg": 89942,
	"./authors/alexandru-david.jpg": 58861,
	"./authors/andrea-bellomia.jpg": 17910,
	"./authors/bajram-hushi.jpg": 16786,
	"./authors/carlo-vassallo.jpg": 81070,
	"./authors/davide-cerato.jpg": 98466,
	"./authors/kristian-notari.jpg": 71129,
	"./authors/lorenzo-beccaro.jpg": 35216,
	"./authors/marco-tanzola.jpg": 19915,
	"./authors/michael-andolino.jpg": 54932,
	"./authors/no_avatar.jpg": 4403,
	"./authors/valerio-buzzelli.jpg": 28078,
	"./bigData.jpg": 55547,
	"./blog/2024-img-articolo-dicembre1.jpg": 24681,
	"./blog/2024-img-articolo-dicembre2-1.jpg": 31683,
	"./blog/2024-img-articolo-dicembre2.jpg": 16149,
	"./blog/2024-img-articolo-novembre1.jpg": 5914,
	"./blog/2024-img-articolo-novembre2.jpg": 25039,
	"./blog/2025-img-articolo-febbraio1.jpg": 96231,
	"./blog/2025-img-articolo-febbraio2.jpg": 12392,
	"./blog/2025-img-articolo-gennaio1.jpg": 37954,
	"./blog/2025-img-articolo-gennaio2.jpg": 40684,
	"./blog/2025-img-articolo-marzo1.jpg": 75008,
	"./blog/2025-img-articolo-marzo2.jpg": 51861,
	"./blog/2025-real-time-data.jpg": 82913,
	"./blog/5-applicazioni-machine-learning-aziende.jpg": 25252,
	"./blog/L'Architettura-a-Microservizi.jpg": 74044,
	"./blog/PWAs-VS-APPN.jpg": 23062,
	"./blog/Progressive-Web-Apps.jpg": 16805,
	"./blog/Uso-del-Cloud.jpg": 24786,
	"./blog/accessibilita-inclusivita-sviluppo-software-custom.jpg": 16628,
	"./blog/agile-development-orangeloop.jpg": 24048,
	"./blog/agile-devops.jpg": 97007,
	"./blog/ai-coding-competences-tools-training.jpg": 76965,
	"./blog/angular-sviluppo-custom.jpg": 98845,
	"./blog/angular-vue-flutter-quale-scegliere-app-personalizzate.jpg": 49046,
	"./blog/api-first-architettura-sistemi-flessibili.jpg": 82760,
	"./blog/app-cross-platform-vantaggi-per-aziende-orangeloop.jpg": 50377,
	"./blog/app-mobile-custom-vantaggi-svantaggi.jpg": 2306,
	"./blog/app-native-ibride-web-vantaggi-svantaggi.jpg": 82202,
	"./blog/applicazioni-ar-vr-ecommerce.jpg": 19794,
	"./blog/applicazioni-cross-platform-vantaggi-per-aziende-orangeloop.jpg": 57833,
	"./blog/architettura-micro-frontend-enterprise-scalabilita-manutenibilita-autonomia.jpg": 36777,
	"./blog/astrorei-come-migliorare-lavoro-da-remoto-consigli-per-developers.jpg": 90021,
	"./blog/astrorei-sviluppo-software-in-outsourcing-quale-modalità-scegliere.jpg": 92359,
	"./blog/backend-per-iot.jpg": 15120,
	"./blog/big-data-business-intelligence-sfruttare-i-dati.jpg": 62060,
	"./blog/blockchain-contratti-digitali-aziende.jpg": 61784,
	"./blog/business-intelligence-data-analysis-cover.jpg": 21775,
	"./blog/business-intelligence-data-analysis.jpg": 32129,
	"./blog/chatgpt-python.jpg": 70546,
	"./blog/ci-cd-intelligente-machine-learning-1.jpg": 92228,
	"./blog/ci-cd-intelligente-machine-learning.jpg": 58333,
	"./blog/creare-connessioni-importanza-network.jpg": 74899,
	"./blog/creare-mvp-vincente.jpg": 21886,
	"./blog/cultura-aziendale-positiva.jpg": 31714,
	"./blog/developer-experience-platform-engineering-astrorei-produttivita-retention.jpg": 69075,
	"./blog/devops-i-vantaggi-nello-sviluppo.jpg": 96557,
	"./blog/differenza-backend-frontend-fullStack-iceberg.jpg": 92534,
	"./blog/disaster-recovery-cloud-native-business-continuity.jpg": 54778,
	"./blog/explainable-ai-2025-1.jpg": 66119,
	"./blog/fasi-della-metodologia-devops-orangeloop.jpg": 21706,
	"./blog/feature-flags-progressive-delivery-rilasci-incrementali-sicuri-astrorei.jpg": 54197,
	"./blog/finops-aziende-crescita-governance-cloud-cost-optimization-innovazione.jpg": 57381,
	"./blog/flessibilita-sul-lavoro.jpg": 52970,
	"./blog/flutter-sviluppo-custom.jpg": 15516,
	"./blog/formazione-aziendale-perche-e-importante.jpg": 44221,
	"./blog/frontend-backend-full-stack-developer-differenze-orangeloop.jpg": 89332,
	"./blog/governance-mlops-pmi-monitoraggio-sicurezza-compliance.jpg": 16167,
	"./blog/hackathon-cose-come-funziona-per-sviluppatori-astrorei.jpg": 17728,
	"./blog/human-augmentation.jpg": 47588,
	"./blog/img-articolo-ottobre1.jpg": 85594,
	"./blog/img-articolo-ottobre2.jpg": 34856,
	"./blog/img_articolo_settembre1.jpg": 62923,
	"./blog/img_articolo_settembre2.jpg": 15668,
	"./blog/implementare-blockchain.jpg": 7530,
	"./blog/ingegneria-software-sostenibile-strategie-green-cto-team-it.jpg": 79224,
	"./blog/lifelong-learning-programmatori-cos'è-perché-Importante.jpg": 22640,
	"./blog/low-code-development-cose-vantaggi-migliori-piattaforme.jpg": 77702,
	"./blog/low-code_Astrorei.jpg": 31930,
	"./blog/metaverso-cosa-rappresenta-per-gli-sviluppatori-orangeloop.jpg": 69859,
	"./blog/migliori-framework-app-cross-platform-orangeloop.jpg": 89380,
	"./blog/migliori-strumenti-per-business-intelligence.jpg": 82886,
	"./blog/minimum-viable-product-come-puo-ridurre-rischi-azienda-astrorei.jpg": 63555,
	"./blog/modernizzare-business-intelligence-pmi-data-mesh-vs-data-warehouse.jpg": 21926,
	"./blog/mvp-minimum-viable-product-cos-e-perche-e-fondamentale-orangeloop.jpg": 10194,
	"./blog/observability-cloud-native-serverless-applications.jpg": 91587,
	"./blog/orangeloop-analisi-dati-come-prendere-decisioni-aziendali-strategiche.jpg": 48222,
	"./blog/orangeloop-big-data-analytics-come-migliorare-performance-applicazioni-aziendali.jpg": 99767,
	"./blog/orangeloop-code-refactoring-nell-agile-tutti-i-vantaggi.jpg": 21862,
	"./blog/orangeloop-intelligenza-artificiale-sviluppo-software.jpg": 68857,
	"./blog/orangeloop-migliorare-life-work-balance-guida-per-sviluppatori.jpg": 11442,
	"./blog/orangeloop-migliore-ide-python-come-sceglierlo.jpg": 41619,
	"./blog/outsourcing-o-sviluppo-in-house-quale scegliere.jpg": 38412,
	"./blog/perche-scegliere-sviluppo-software-personalizzato.jpg": 96256,
	"./blog/pwa-trend-sviluppo-software.jpg": 93862,
	"./blog/pwa-vs-native.jpg": 95866,
	"./blog/pycharm-cose-perche-sceglierlo.jpg": 17804,
	"./blog/quantum-computing-software-ai-2025.jpg": 2740,
	"./blog/resilience-software-sistemi-business-critical-architettura-recovery-observability.jpg": 56584,
	"./blog/serverless-vantaggi-svantaggi.jpg": 66561,
	"./blog/software-composition-analysis-proteggere-dipendenze-open-source-supply-chain-software.jpg": 32682,
	"./blog/sprint_metodologia_di_sviluppo_agile_orangeloop.jpg": 96498,
	"./blog/step-selezione-astrorei.jpg": 44572,
	"./blog/sviluppare-con-react-vantaggi-aziende-orangeloop.jpg": 82322,
	"./blog/sviluppo-low-code-trasformazione-digitale.jpg": 67078,
	"./blog/sviluppo-software-10-trend-2024.jpg": 21696,
	"./blog/system-integration-perche-importante-per-aziende-orangeloop.jpg": 84039,
	"./blog/team-working-azienda-perche-importante.jpg": 16034,
	"./blog/tecnologia-blockchain.jpg": 81550,
	"./blog/ten-growing-trends-part-2.jpg": 50075,
	"./blog/ux-ui-and-programming-development-technology.jpg": 38131,
	"./blog/vue-sviluppo-custom.jpg": 74746,
	"./consulenza-strategica-per-aziende-astrorei.jpg": 26811,
	"./custom-software-sviluppo-su-misura-astrorei.jpg": 19926,
	"./desktopApp.jpg": 87925,
	"./dev_hero.jpg": 91942,
	"./devops.jpg": 93813,
	"./dotnetDev.jpg": 3174,
	"./experts/andrea.jpg": 98333,
	"./experts/bajram.jpg": 9781,
	"./experts/carlo.jpg": 51627,
	"./experts/davide.jpg": 8133,
	"./experts/emanuele.jpg": 94234,
	"./experts/kristian.jpg": 71302,
	"./experts/lorenzo.jpg": 93258,
	"./experts/marco.jpg": 87909,
	"./experts/michael.jpg": 72240,
	"./experts/romeo.jpg": 33190,
	"./experts/sara-petrocchi.jpg": 56750,
	"./experts/valerio.jpg": 97159,
	"./experts/vishal.jpg": 41623,
	"./frontendDev.jpg": 37446,
	"./hero.jpg": 55021,
	"./home_service_1.jpg": 69466,
	"./home_service_2.jpg": 2266,
	"./iot.jpg": 71511,
	"./javaDev.jpg": 92810,
	"./join.jpg": 41231,
	"./lavora-con-noi-astrorei.jpg": 8992,
	"./llm.jpg": 68061,
	"./mobileApp.jpg": 70605,
	"./mvp.jpg": 36901,
	"./napoleon_hill.jpg": 90983,
	"./nodejsDev.jpg": 20960,
	"./orangeloop-27.jpg": 17705,
	"./orangeloop-29.jpg": 15134,
	"./orangeloop-32.jpg": 27467,
	"./orangeloop-34.jpg": 83436,
	"./orangeloop-37.jpg": 92976,
	"./orangeloop-52.jpg": 88243,
	"./phpDev.jpg": 71501,
	"./pythonDev.jpg": 29835,
	"./rustDev.jpg": 52064,
	"./sales-rappresentative.jpg": 37701,
	"./schumpeter.jpg": 843,
	"./systemIntegrationAutomation.jpg": 21401,
	"./team-sviluppo-dedicato-outsourcing-astrorei.jpg": 39871,
	"./team.jpg": 38718,
	"./testimonials/molaschi.jpg": 44697,
	"./use-case/mechit.jpg": 55218,
	"./vr.jpg": 99160,
	"./webApp.jpg": 24887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;